import { render, staticRenderFns } from "./CopyIconStatic.vue?vue&type=template&id=291da3b8&scoped=true"
import script from "./CopyIconStatic.vue?vue&type=script&lang=js"
export * from "./CopyIconStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291da3b8",
  null
  
)

export default component.exports